import meetingService from '@/services/api/plataformas/meeting';

export default {
  namespaced: true,
  modules: {
    meeting: meetingService,
  },
};
